export { AvailabilityColorPipe } from './lib/availability-color.pipe';
export { ResourceTitlePipe } from './lib/resource-title.pipe';
